import { createContext } from 'react'

export const ProjectContext = createContext(null)
